import React from 'react';
import qs from 'query-string';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  bootstrapLoginAutomated
} from './actions';

/*
import {
  selectApiData
} from './selectors';
*/

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

/*
const getMyIp = (apiData) => (
  (apiData && apiData.origin) && apiData.origin.split(', ')[1]
);
*/

/**
 * Representa el componente container Home
 *
 * @class LoginAtuomated
 * @extends {React.Component}
 */
export class LoginAtuomated extends React.Component {

  componentWillMount() {
    const { actions } = this.props;
    // eslint-disable-next-line
    const data = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    actions.bootstrapLoginAutomated(data);
  }

  render() {
    /*
    const {
     apiData
    } = this.props;
    */

    return (
      <div className="login">
        <div>
          <p className="home-intro">
            Validando seu numero Vivo......
          </p>
          <span className="ouro ouro3">
            <span className="left"><span className="anim" /></span>
            <span className="right"><span className="anim" /></span>
          </span>
        </div>
      </div>
    );
  }
}

/*
LoginAtuomated.defaultProps = {
  apiData: {}
};
*/


LoginAtuomated.propTypes = {
  actions: PropTypes.object.isRequired
};

/*
const mapStateToProps = (state) => ({
  apiData: selectApiData(state)
});
*/


const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    bootstrapLoginAutomated
  }, dispatch)
});


export default connect(() => ({}), mapDispatchToProps)(LoginAtuomated);



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/index.js